import { COMMON_GCF_COMPONENT_CONFIG } from './gcfComponentCommonConfig';

export const LISTING_VISUAL_GALLERY_COMPONENT_CONFIG = {
  ...COMMON_GCF_COMPONENT_CONFIG,
};
